import React from "react";

import "./Toggle.scss";

export type ToggleProps = {
  cx?: string;
  clickState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const Toggle: React.FC<ToggleProps> = ({ cx = "", clickState }) => {
  const [click, setClick] = clickState;
  return (
    <div
      className={`Toggle ${click} ${cx}`}
      onClick={() => setClick((_) => !click)}
    >
      <div className={"thumb"} />
    </div>
  );
};
